/** 
 * @type {ProjectAccountsFilter} 
 */ 
 const filter = { 
with: null, 
orderBy: null, 
ids: null, 
project_ids: null, 
} 
 /** 
 * @returns {ProjectAccountsFilter} 
 */ 
 export default function () { 
 return JSON.parse(JSON.stringify(filter)); 
 } 



// WEBPACK FOOTER //
// ./resources/js/filters/ProjectAccountsFilter.js